export default __webpack_public_path__ + "static/top-sealing-caption-badda6488ba62c2e81162452cd136564.svg";